<template>
    <UsageLimitModal
        v-model:visible="visible"
        :title="t('draftingCreditsLimitModal.title')"
        :list="benefitList"
        :buttonText="t('draftingCreditsLimitModal.buttonText')"
        :upgradeUrl="upgradeUrl"
        @upgrade="handleUpgrade"
    >
        <template #description>
            <span class="pro-credits-limit-modal__description-line">
                {{ t('draftingCreditsLimitModal.descriptionLine1') }}
            </span>
            <span class="pro-credits-limit-modal__description-line">
                {{ t('draftingCreditsLimitModal.descriptionLine2') }}
            </span>
        </template>
    </UsageLimitModal>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { UsageLimitModal } from 'patsnap-biz';
import { useUserPackage } from '@/composables/useUserPackage';
import { useProCreditsLimitModal } from '../composables/use-pro-credits-limit-modal';
import { buildUpgradeHref, createUpgradeTrackingContext, trackUpgradeTrigger } from '@/utils/upgrade-tracking';

const { t } = useI18n();
const { visible, agentName, close } = useProCreditsLimitModal();
const { init } = useUserPackage();

const upgradeContext = computed(() => createUpgradeTrackingContext({
    trigger_source: 'paywall',
    agent_name: agentName.value,
}));
const upgradeUrl = computed(() => buildUpgradeHref(upgradeContext.value));

const benefitList = computed(() => [
    t('draftingCreditsLimitModal.list.moreCredits'),
    t('draftingCreditsLimitModal.list.moreDrafts'),
    t('draftingCreditsLimitModal.list.priorityFeatures'),
]);

onMounted(() => {
    init().catch((error) => {
        console.warn('[ProCreditsLimitModal] Failed to initialize user package:', error);
    });
});

function handleUpgrade() {
    trackUpgradeTrigger(upgradeContext.value);
    close();
}
</script>

<style lang="scss">
.pro-credits-limit-modal__description-line {
    display: block;
}
</style>
